import React from "react";
import { Link } from "react-router-dom";

const RoleToggle = ({ active }) => {
  return (
    <div className="auth-toggle a-font">
      <Link to="/sign-up" className={active === "renter" ? "active" : ""}>
        Rent storage
      </Link>
      <Link to="/sign-up-storage-provider" className={active === "provider" ? "active" : ""}>
        List my storage
      </Link>
    </div>
  );
};

export default RoleToggle;
